var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 6.33308V9.49975M8.5415 4.35391H5.6665C4.26637 4.35391 3.56631 4.35391 3.03153 4.61277C2.56112 4.84047 2.17867 5.2038 1.93899 5.65069C1.6665 6.15873 1.6665 6.82379 1.6665 8.15392L1.6665 9.10391C1.66651 9.84166 1.66651 10.2105 1.79337 10.5015C1.96253 10.8895 2.28699 11.1977 2.69536 11.3584C3.00165 11.4789 3.38994 11.4789 4.16651 11.4789V14.8435C4.16651 15.0273 4.16651 15.1192 4.17453 15.1966C4.25247 15.9483 4.87852 16.5431 5.66981 16.6171C5.75129 16.6247 5.84803 16.6247 6.04151 16.6247C6.23498 16.6247 6.33172 16.6247 6.4132 16.6171C7.2045 16.5431 7.83054 15.9483 7.90848 15.1966C7.91651 15.1192 7.91651 15.0273 7.91651 14.8435V11.4789H8.54151C10.0135 11.4789 11.8142 12.2285 13.2034 12.948C14.0139 13.3677 14.4191 13.5775 14.6845 13.5466C14.9306 13.518 15.1167 13.413 15.2609 13.2215C15.4165 13.0149 15.4165 12.6015 15.4165 11.7748V4.05806C15.4165 3.23133 15.4165 2.81796 15.2609 2.61137C15.1167 2.41979 14.9306 2.31482 14.6845 2.28618C14.4191 2.2553 14.0139 2.46515 13.2034 2.88486C11.8142 3.60429 10.0135 4.35391 8.5415 4.35391Z",
    stroke: "#2B3D4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.fe1fa1a18e6fc15b0b0d7807e1bab791.svg";
export { ForwardRef as ReactComponent };